var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 44 79",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "rightarrow",
    transform: "matrix(1,0,0,1,-430,-278)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-6.12323e-17,-1,-1,6.12323e-17,915.417,1476.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "one",
    x: 1153.31,
    y: 444.521,
    width: 9.974,
    height: 9.974
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,875.521,-840.385)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "two",
    x: 1133.36,
    y: 424.573,
    width: 9.974,
    height: 9.974
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,855.573,-840.385)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "three",
    x: 1123.38,
    y: 414.599,
    width: 9.974,
    height: 9.974
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,895.469,-840.385)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "four",
    x: 1143.33,
    y: 434.547,
    width: 9.974,
    height: 9.974
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,895.469,-840.385)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "five",
    x: 1163.28,
    y: 434.547,
    width: 9.974,
    height: 9.974
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-6.12323e-17,-6.12323e-17,-1,440.974,342.841)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "six",
    x: 0,
    y: 0,
    width: 9.974,
    height: 9.974
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-6.12323e-17,-6.12323e-17,-1,431,352.815)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "seven",
    x: 0,
    y: 0,
    width: 9.974,
    height: 9.974
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.74bb59c1.svg";
export { ForwardRef as ReactComponent };